import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { z } from 'zod';
import {
  EngineAddPage,
  EngineBasicSettingsPage,
} from './pages/EngineBasicSettingsPage';
import { EngineListPage } from './pages/EngineListPage';
import { EngineQueueSettingsPage } from './pages/EngineQueueSettingsPage';
import { FieldAddPage, FieldDetailPage } from './pages/FieldDetailPage';
import {
  basePath,
  ENGINE_ID_KEY,
  engineBasicSettingsPath,
  engineBasicSettingsRoute,
  engineFieldDetailRoute,
  engineFieldNewRoute,
  engineNewRoute,
  engineQueueSettingsRoute,
  oldEngineDetailRoute,
} from './paths';

export const EngineRoutes = () => {
  const match = useRouteMatch<{ [ENGINE_ID_KEY]: string }>(
    oldEngineDetailRoute
  );

  return (
    <Switch>
      <Route exact path={engineNewRoute} component={EngineAddPage} />

      <Route
        exact
        path={oldEngineDetailRoute}
        render={() => {
          // match should always be defined here
          const parsed = z.coerce
            .number()
            .safeParse(match?.params[ENGINE_ID_KEY]);

          return (
            <Redirect
              to={
                parsed.success ? engineBasicSettingsPath(parsed.data) : basePath
              }
            />
          );
        }}
      />
      <Route
        exact
        path={engineBasicSettingsRoute}
        component={EngineBasicSettingsPage}
      />

      <Route
        exact
        path={engineQueueSettingsRoute}
        component={EngineQueueSettingsPage}
      />
      <Route exact path={engineFieldNewRoute} component={FieldAddPage} />
      <Route exact path={engineFieldDetailRoute} component={FieldDetailPage} />
      <Route path={basePath} component={EngineListPage} />
      <Redirect to={basePath} />
    </Switch>
  );
};
